module.exports = __webpack_public_path__ + "img/validation.4e9ac278.svg";